
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/quiz-me",
      function () {
        return require("private-next-pages/articles/quiz-me.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/quiz-me"])
      });
    }
  